export class InvalidParamError extends Error {}
